
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      showReminderModal: false,
      reminderIntervalHandle: null,
      leadsIntervalHandle: null,
    }
  },

  computed: {
    ...mapState('reminders', ['personalReminders']),
    currentReminders() {
      if (!Array.isArray(this.personalReminders)) return []
      return this.personalReminders.filter((reminder) => {
        const diffMinutes = this.$dateFns.differenceInMinutes(
          this.$dateFns.parseISO(reminder.remind_on),
          new Date()
        )

        return diffMinutes <= 15 && !reminder.is_done
      })
    },
  },

  mounted() {
    // Load Reminders
    this.loadPersonalReminders()
    this.reminderIntervalHandle = setInterval(
      this.loadPersonalReminders,
      1000 * 30
    )

    // Load Leads
    if (this.$can('customer.view-leads')) {
      this.loadAll()
      this.leadsIntervalHandle = setInterval(this.loadAll, 1000 * 60)
    }
  },

  beforeDestroy() {
    clearInterval(this.reminderIntervalHandle)
  },

  methods: {
    ...mapActions('reminders', ['loadPersonalReminders']),
    ...mapActions('leads', ['loadAll']),

    closeReminderModal() {
      this.showReminderModal = false
    },
  },
}
